import { render } from "./AgendaUpcomingWidget.vue?vue&type=template&id=b253e794"
import script from "./AgendaUpcomingWidget.vue?vue&type=script&lang=js"
export * from "./AgendaUpcomingWidget.vue?vue&type=script&lang=js"

import "./AgendaUpcomingWidget.vue?vue&type=style&index=0&id=b253e794&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__